import React, { memo } from "react";

import { Copyright, WrapperBottom } from "./styles";

const BottomSection = () => {
  const currentYear = new Date().getFullYear();

  return (
    <WrapperBottom>
      <Copyright> © 2008-{currentYear} Cart2Cart</Copyright>
    </WrapperBottom>
  );
};

export default memo(BottomSection);
